import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TAny } from "@app/lib/models/common.type";
import { IResponse } from "@app/lib/models/response.model";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { Observable } from "rxjs";
import { IDTypeResponse } from "../models/document-details.model";
import { MenuNode, RoleMenu } from "../models/role-menu-mapping.model";



@Injectable({
    providedIn: 'root'
})
export class RoleMenuMappingService extends BaseHttpService {
    

    constructor(
        http: HttpClient,
        appConfig: AppConfiguration,
    ) {
        super(http, appConfig);
    }
    searchParties(reqBody: TAny) {
        return this.post<IResponse<any>, TAny>('parties/fetch.htm', reqBody);
    }
    
   
    getRoles() {
            return this.get<IResponse<RoleMenu[]>>('role-menu-mapping/get-roles.htm');
        }
    getData(reqParams: any) {
        return this.get<IResponse<MenuNode[]>>('role-menu-mapping/get/menu-items/per-role.htm',{params:reqParams});
    }
    getParentMenu(reqParams: any) {
        return this.get<IResponse<MenuNode[]>>('role-menu-mapping/get/parent-menus.htm',{params:reqParams});
    }
    insertMenu(reqBody: any,roleId:any) {
        return this.post<IResponse<any>, TAny>('role-menu-mapping/insert.htm', reqBody,{params:roleId});
    }
    
    upsertMenu(reqBody: any,roleId:any) {
        return this.post<IResponse<any>, TAny>('role-menu-mapping/update.htm', reqBody,{params:roleId});
    }
}